<div class="home-wrapper">

  <img src="/assets/motherboard.png" alt="Hero background" class="global-bg-fallback" />

  <div class="scroll-container">

    <div class="hero-section" id="home">
      <app-hero></app-hero>
    </div>

    <div class="content-section">
      <ng-template #contentContainer></ng-template>
    </div>

  </div>

</div>